import React, { Component } from 'react';
import { Button, Dropdown, Segment, Visibility, Responsive, Container, Menu, Image } from 'semantic-ui-react';
import {NavLink} from 'react-router-dom';

import '../css/navbar.css';

const logo=require('../img/logo.svg');


class NavbarComputer extends Component {
  state = {}

  hideFixedMenu = () => this.setState({ fixed: false })
  showFixedMenu = () => this.setState({ fixed: true })

  render() {
    const { fixed } = this.state
    return (

      <Visibility once={false} onBottomPassed={this.showFixedMenu} onBottomPassedReverse={this.hideFixedMenu}>
        <Segment textAlign='center' style={{ padding: '0em 0em' }} vertical>
          <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <Menu
            fixed={fixed ? 'top' : null}
            style={{paddingTop:'0em', paddingBottom: '0em', marginTop:'0em', marginBottom:'0em'}}
            secondary={!fixed}
            size='small'
            borderless
          >
            <Container>
              <Menu.Item as='a' href='/home' position='left'><Image src={logo} style={{height:'3em', width:'auto'}} title='BeemaBroker' /></Menu.Item>
              <Menu.Menu position='right'>
                <Menu.Item style={{ fontSize: '1.2em'}} name='About' as={NavLink} exact to='/about'><b>About</b></Menu.Item>
                <Menu.Item style={{ fontSize: '1.2em'}} as='a' href='https://medium.com/beemabroker'> <b>Blog</b></Menu.Item>
                <Menu.Item style={{ fontSize: '1.2em'}} as='a' href='/home#contact'><b>Contact</b></Menu.Item>
                <Dropdown style={{ fontSize: '1.2em'}} item text='Products'>
                  <Dropdown.Menu>
                    <Dropdown.Header style={{color:'magenta'}}>Fundraising</Dropdown.Header>
                    <Dropdown.Item>Directors & Officers</Dropdown.Item>
                    <Dropdown.Header style={{color:'magenta'}}>Have Employees</Dropdown.Header>
                    <Dropdown.Item>Workers Compensation</Dropdown.Item>
                    <Dropdown.Item>Employment Practices Liability</Dropdown.Item>
                    <Dropdown.Header style={{color:'magenta'}}>Product/Service</Dropdown.Header>
                    <Dropdown.Item>Tech Errors & Omissions</Dropdown.Item>
                    <Dropdown.Item>Professional Liability</Dropdown.Item>
                    <Dropdown.Item>Product Liability</Dropdown.Item>
                    <Dropdown.Header style={{color:'magenta'}}>Can be Bundled</Dropdown.Header>
                    <Dropdown.Item>Property</Dropdown.Item>
                    <Dropdown.Item>General Liability</Dropdown.Item>
                    <Dropdown.Item>Business Auto</Dropdown.Item>
                    <Dropdown.Item>Umbrella</Dropdown.Item>
                    <Dropdown.Item>Business Owner Policy</Dropdown.Item>
                    <Dropdown.Header style={{color:'magenta'}}>Important</Dropdown.Header>
                    <Dropdown.Item>Cyber</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Menu.Item><Button color='pink' floated='right' as='a' compact href='/home#request-acesss'><b>Request Access</b></Button></Menu.Item>
              </Menu.Menu>
            </Container>
          </Menu>
              </Responsive>
        </Segment>
      </Visibility>

    );
  }
};

export default NavbarComputer;



// WEBPACK FOOTER //
// ./src/js/NavbarComputer.js